import React, { useState, useEffect, useMemo } from "react";
import { useMoreStockContext } from "../../context/MoreStockContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import "./StockTestDetail.css";
import { useNavigate, useParams } from "react-router-dom";
import { FiRefreshCw } from "react-icons/fi";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useSecurityMaster } from "../../context/SecurityMasterContext";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { usePrediction } from "../../context/PredictionContext";
import { useWatchlist } from "../../context/WatchlistContext";
import { useAuth } from "../../context/AuthNewContext";
import { nseIndicesOptions } from "../Helper/Helperdata";
import { FiStar } from "react-icons/fi"; // outline
import { FaStar } from "react-icons/fa"; // filled
import { FiMinusCircle } from "react-icons/fi";
import useLivePrices from "../../hooks/useLivePrices";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import IndexTabs from "../IndexTabs/IndexTabs";
const StockTestDetail = () => {
  const { data } = useMoreStockContext();
  // const { type } = useParams();
  const [changeFilter, setChangeFilter] = useState("all");
  const [latestDataIndex, setLatestDataIndex] = useState("");
  const [companySort, setCompanySort] = useState("none");
  const [percentSort, setPercentSort] = useState("none");
  const [signalSort, setSignalSort] = useState("none");
  const [lastUpdate, setLastUpdate] = useState("");
  const [volumeFilter, setVolumeFilter] = useState("all");
  const [alphaFilter, setAlphaFilter] = useState("all");
  const [securityData, setSecurityData] = useState("");
  const navigate = useNavigate();
  console.log("date from context", data);

  const { predictionMap, fetchPredictions, loading, error, lastUpdated } =
    usePrediction();
  const {
    watchlist,
    fetchWatchlist,
    addToWatchlist,
    removeFromWatchlist,
    resetWatchlist,

    isInWatchlist,
  } = useWatchlist();
  const {
    // loadDashboardIndexMarket,
    // dashboardMarketData,
    // resetDashboardMarketData,
    // dashboardLoading,
    // dashboardError,
    getDashboardData,
    dashboardData,
    dashboardDataLoading,
    // dashboardIndexData,
  } = useMarketSnapshot();

  const {
    prices: livePrices,
    isLive,
    lastTickTime,
    subscribeSymbols,
  } = useLivePrices();

  const {
    indicesData,
    getNseIndices,
    getNseIndexData,
    // nseIndexData,
    getLatestNseData,
    latestNseData,
  } = useMarketIndicators();
  const { getSecurityIds } = useSecurityMaster();
  const { user } = useAuth();
  const userID = user?.userID;

  //  const [selectedIndex, setSelectedIndex] = useState(() => {
  //   return type || localStorage.getItem("selectedIndex") || "NIFTY 50";
  // });
  // const { selectedIndex: indexParam, type } = useParams();

  // const [selectedIndex, setSelectedIndex] = useState(
  //   decodeURIComponent(indexParam || "NIFTY 50"),
  // );
  const { selectedIndex: indexParam, type } = useParams();

  const [selectedIndex, setSelectedIndex] = useState(() => {
    const routeIndex = indexParam ? decodeURIComponent(indexParam) : null;

    return routeIndex || localStorage.getItem("selectedIndex") || "NIFTY 50";
  });
  useEffect(() => {
    if (!selectedIndex) return;

    localStorage.setItem("selectedIndex", selectedIndex);
  }, [selectedIndex]);

  const viewMode = type || "all";
  const normalizedData = data.map((item) => ({
    ticker_id: item.identifier, // required for key
    company: item.symbol, // used in table
    ticker: item.symbol,
    price: item.lastPrice,
    open: item.open,
    close: item.previousClose,
    low: item.dayLow,
    high: item.dayHigh,
    volume: item.totalTradedVolume,
    percent_change: item.pChange ?? 0,
  }));
  const formatVolume = (volume) => {
    if (volume == null) return "-"; // catches null & undefined

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };
  const dataToRender = normalizedData;

  const handleChangeSort = (value) => {
    setChangeFilter(value);
    setVolumeFilter("all");
  };

  const handleVolumeSort = (value) => {
    setVolumeFilter(value);
    setChangeFilter("all");
  };
  // const handleIndexSelect = (e) => {
  //   const value = e.target.value;
  //   console.log("value seleect", value);
  //   setSelectedIndex(value);

  //   if (!value) return;

  //   // getNseIndexData(value);
  //   getLatestNseData(value);
  // };
  const handleIndexSelect = (e) => {
    const value = e.target.value;

    if (!value) return;

    // resetDashboardMarketData();
    // setLatestDataIndex("");

    setSelectedIndex(value);
  };

  // const nseIndicesOptions = [
  //   "NIFTY 50",
  //   "NIFTY BANK",
  //   "NIFTY IT",
  //   "NIFTY NEXT 50",
  //   "NIFTY MIDCAP 100",
  // ];
  // console.log("nseIndex data", nseIndexData);
  //previous code using live nse api
  // const indexSymbolData = nseIndexData?.data?.data;
  //new code w=using cache and db
  const indexSymbolData = latestNseData?.data;
  console.log("Index symbol data", indexSymbolData);

  const dataToRender1 = indexSymbolData?.filter((item) => item?.priority !== 1);
  console.log("Data to render 1", dataToRender1);
  const symbols = useMemo(() => {
    if (!indexSymbolData) return [];
    return indexSymbolData
      .filter((item) => item?.priority !== 1)
      .map((item) => item.symbol);
  }, [indexSymbolData]);

  console.log("Symbols", symbols);
  const normalizedIndexData =
    dataToRender1?.map((item) => ({
      ticker_id: item.symbol,
      company: item.symbol,
      ticker: item.symbol,
      price: item.lastPrice,
      open: item.open,
      close: item.previousClose,
      low: item.dayLow,
      high: item.dayHigh,
      volume: item.totalTradedVolume,
      percent_change: item.pChange ?? 0,
    })) || [];
  const baseData =
    selectedIndex && normalizedIndexData.length > 0
      ? normalizedIndexData
      : normalizedData;
  const dashboardRows = useMemo(() => {
    const rows = dashboardData?.data;

    if (Array.isArray(rows)) {
      return rows;
    }

    return Object.values(rows || {});
  }, [dashboardData?.data]);
  // const snapshotRows = Object.values(dashboardMarketData || []);
  const snapshotRows = dashboardRows;

  // const filteredData = snapshotRows.sort((a, b) => {
  //   const quoteA = a?.quote?.data;
  //   const quoteB = b?.quote?.data;

  //   if(viewMode==="gainers")

  //   if (changeFilter === "high") {
  //     return (
  //       ((quoteB?.last_price - quoteB?.ohlc?.close) / quoteB?.ohlc?.close) *
  //         100 -
  //       ((quoteA?.last_price - quoteA?.ohlc?.close) / quoteA?.ohlc?.close) * 100
  //     );
  //   }

  //   if (changeFilter === "low") {
  //     return (
  //       ((quoteA?.last_price - quoteA?.ohlc?.close) / quoteA?.ohlc?.close) *
  //         100 -
  //       ((quoteB?.last_price - quoteB?.ohlc?.close) / quoteB?.ohlc?.close) * 100
  //     );
  //   }

  //   if (alphaFilter === "az") return a.symbol.localeCompare(b.symbol);
  //   if (alphaFilter === "za") return b.symbol.localeCompare(a.symbol);

  //   return 0;
  // });

  //new code
  const filteredData = [...snapshotRows].sort((a, b) => {
    const quoteA = a?.quote?.data;
    const quoteB = b?.quote?.data;

    const percentA =
      quoteA?.ohlc?.close > 0
        ? ((quoteA?.last_price - quoteA?.ohlc?.close) / quoteA?.ohlc?.close) *
          100
        : 0;

    const percentB =
      quoteB?.ohlc?.close > 0
        ? ((quoteB?.last_price - quoteB?.ohlc?.close) / quoteB?.ohlc?.close) *
          100
        : 0;

    const volumeA = quoteA?.volume || 0;
    const volumeB = quoteB?.volume || 0;

    if (viewMode === "Gainers") {
      return percentB - percentA;
    }

    if (viewMode === "Losers") {
      return percentA - percentB;
    }

    if (viewMode === "Most Active") {
      return volumeB - volumeA;
    }

    if (changeFilter === "high") {
      return percentB - percentA;
    }

    if (changeFilter === "low") {
      return percentA - percentB;
    }

    if (volumeFilter === "high") {
      return volumeB - volumeA;
    }

    if (volumeFilter === "low") {
      return volumeA - volumeB;
    }

    if (alphaFilter === "az") return a.symbol.localeCompare(b.symbol);
    if (alphaFilter === "za") return b.symbol.localeCompare(a.symbol);

    return 0;
  });

  const initialIndex = selectedIndex || type;
  // useEffect(() => {
  //   if (!initialIndex) return;

  //   if (selectedIndex === initialIndex) return;

  //   setSelectedIndex(initialIndex);

  //   getLatestNseData(initialIndex);
  // }, [initialIndex]);

  const indexToshow = selectedIndex || type || "";

  console.log("index to show", indexToshow);

  // useEffect(() => {
  //   if (!symbols?.length) return;

  //   const loadSecurityIds = async () => {
  //     try {
  //       const symbolsData = await getSecurityIds(symbols);
  //       console.log("Security IDs:", symbolsData);
  //       setSecurityData(symbolsData);

  //       // use symbolsData here
  //     } catch (err) {
  //       console.error("Failed to load security IDs", err);
  //     }
  //   };

  //   loadSecurityIds();
  // }, [symbols]);

  // useEffect(() => {
  //   if (!selectedIndex) return;

  //   const loadData = async () => {
  //     resetDashboardMarketData();

  //     await getLatestNseData(selectedIndex);

  //     await loadDashboardIndexMarket({
  //       indexName: selectedIndex,
  //     });

  //     setLastUpdate(formatTimestamp());
  //   };

  //   loadData();
  // }, [selectedIndex]);
  // useEffect(() => {
  //   if (!selectedIndex) return;

  //   const fetchIndexData = async () => {
  //     await getLatestNseData(selectedIndex);

  //     setLatestDataIndex(selectedIndex);
  //   };

  //   fetchIndexData();
  // }, [selectedIndex]);
  // useEffect(() => {
  //   if (!selectedIndex) return;
  //   if (!latestDataIndex) return;

  //   if (selectedIndex !== latestDataIndex) return;

  //   if (!latestNseData?.data?.length) return;

  //   loadDashboardIndexMarket({
  //     indexName: selectedIndex,
  //     // stocks: latestNseData.data,
  //   });
  // }, [selectedIndex, latestDataIndex, latestNseData?.data]);
  // useEffect(() => {
  //   if (!selectedIndex) return;

  //   let interval;

  //   const fetchAll = async () => {
  //     resetDashboardMarketData();
  //     await loadDashboardIndexMarket({ indexName: selectedIndex });
  //   };

  //   fetchAll();

  //   interval = setInterval(() => {
  //     if (!document.hidden) fetchAll();
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, [selectedIndex]);

  // ❌ DELETE both old effects
  // ❌ DELETE getLatestNseData call entirely from this component

  // ❌ DELETE these two effects entirely — replaced above
  // useEffect(() => { fetchIndexData... }, [selectedIndex])
  // useEffect(() => { loadDashboardIndexMarket... }, [selectedIndex, latestDataIndex, latestNseData])

  // useEffect(() => {
  //   if (!selectedIndex) return;

  //   let interval;

  //   const fetchAll = async () => {
  //     // await loadDashboardIndexMarket({ indexName: selectedIndex });
  //     await getDashboardData({ indexName: selectedIndex });
  //   };

  //   fetchAll();

  //   interval = setInterval(() => {
  //     if (!document.hidden) fetchAll();
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, [selectedIndex]);
  // const hasDashboardData =
  // Array.isArray(dashboardData?.data) &&
  // dashboardData.data.length > 0;
  
  
  
  const hasDashboardData = dashboardRows.length > 0;
  useEffect(() => {
    if (!selectedIndex) return;

    // TestOHLC already loaded the data into context.
    if (hasDashboardData) {
      console.log("StockTestDetail: using dashboardData from context");
      return;
    }

    getDashboardData({
      indexName: selectedIndex,
    });
  }, [selectedIndex, hasDashboardData, getDashboardData]);
  // useEffect(() => {
  //   if (!selectedIndex) return;

  //   // Get all stock symbols from dashboard data
  //   const stockSymbols = Object.keys(dashboardMarketData || {});
  //   subscribeSymbols([selectedIndex, ...stockSymbols]);
  // }, [selectedIndex, dashboardMarketData]);
  const dashboardSymbols = useMemo(() => {
    return dashboardRows.map((item) => item?.symbol).filter(Boolean);
  }, [dashboardRows]);

  useEffect(() => {
    if (!selectedIndex) return;

    subscribeSymbols([...new Set([selectedIndex, ...dashboardSymbols])]);
  }, [selectedIndex, dashboardSymbols, subscribeSymbols]);
  console.log("Security Data", securityData);
  console.log("dashboard data", dashboardData);

  const sortVolumeHigh = () => {
    setVolumeFilter("high");
    setChangeFilter("all");
    setAlphaFilter("all");
  };
  const sortVolumeLow = () => {
    setVolumeFilter("low");
    setChangeFilter("all");
    setAlphaFilter("all");
  };
  const sortCompanyAsc = () => {
    setAlphaFilter("az");
    setChangeFilter("all");
    setVolumeFilter("all");
  };
  const sortCompanyDesc = () => {
    setAlphaFilter("za");
    setChangeFilter("all");
    setVolumeFilter("all");
  };

  const sortPercentHigh = () => {
    setChangeFilter("high");
    setAlphaFilter("all");
  };

  const sortPercentLow = () => {
    setChangeFilter("low");
    setAlphaFilter("all");
  };

  console.log("Latest nse data", latestNseData);

  // const handleRefresh = async () => {
  //   try {
  //     // refresh NSE data
  //     await getLatestNseData(selectedIndex);

  //     // refresh predictions
  //     if (securityData?.length) {
  //       const payload = securityData.map((item) => ({
  //         symbol: item.symbol,
  //         securityId: item.security_id,
  //       }));

  //       await fetchPredictions(payload);
  //     }

  //     // update timestamp
  //     setLastUpdate(formatTimestamp());

  //     console.log("🔄 Data refreshed");
  //   } catch (err) {
  //     console.error("Refresh failed", err);
  //   }
  // };

  // const advances = dataToRender1?.filter((item) => item?.pChange > 0)?.length;
  // console.log("ADVANCES", advances);
  // const declines = dataToRender1?.filter((item) => item?.pChange < 0)?.length;
  // console.log("Declines", declines);
  // const unChanged = dataToRender1?.filter(
  //   (item) => item?.pChange === 0,
  // )?.length;
  // console.log("UnChanged", unChanged);

  const handleRefresh = async () => {
    try {
      // await loadDashboardIndexMarket({
      //   indexName: selectedIndex,
      // });
      await getDashboardData({
        indexName: selectedIndex,
      });
    } catch (err) {
      console.error("Refresh failed", err);
    }
  };
  const dataForIndex = indexSymbolData?.filter(
    (item) => item?.priority !== 0,
  )?.[0];
  useEffect(() => {
    if (latestNseData || type) {
      setLastUpdate(formatTimestamp());
    }
  }, [latestNseData, type]);
  const handleAdd = async (symbol) => {
    const exists = isInWatchlist(symbol); // ✅ check first

    try {
      if (exists) {
        // 🔥 REMOVE
        await removeFromWatchlist({ userID, symbol });
      } else {
        // 🔥 ADD (your existing logic untouched)
        const res = await getSecurityIds([symbol]);
        const securityId = res?.[0]?.security_id;

        await addToWatchlist({
          userID,
          symbol,
          securityId,
        });
      }
    } catch (err) {
      console.error("Toggle failed:", err);
    }
  };
  useEffect(() => {
    if (userID) {
      fetchWatchlist(userID);
    }
  }, [userID]);
  console.log("watchlist", watchlist);
  // const currentMarketRows = Object.values(dashboardMarketData || {});
  const currentMarketRows = dashboardRows;

  const latestQuoteTimestamp = currentMarketRows.reduce((latest, item) => {
    const current = new Date(item?.quote_updated_at);

    return current > latest ? current : latest;
  }, new Date(0));

  const latestIntradayTimestamp = currentMarketRows.reduce((latest, item) => {
    const current = new Date(item?.intraday_updated_at);

    return current > latest ? current : latest;
  }, new Date(0));

  const formatTimestamp = (dateValue) => {
    if (!dateValue) return "";

    const now = new Date(dateValue);

    if (isNaN(now)) return "";

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} | ${time}`;
  };

  const formattedQuoteTime = formatTimestamp(latestQuoteTimestamp);

  const snapshotStocks = currentMarketRows
    .map((item) => {
      const quote = item?.quote?.data;

      const lastPrice = quote?.last_price;
      const prevClose = item?.prev_close || quote?.ohlc?.close;

      const pChange =
        prevClose && lastPrice
          ? Number((((lastPrice - prevClose) / prevClose) * 100).toFixed(2))
          : 0;

      return {
        symbol: item?.symbol,
        security_id: item?.security_id,

        lastPrice,
        pChange,
        prediction: item?.prediction,

        totalTradedVolume: quote?.volume || 0,
        dayLow: quote?.ohlc?.low,
        dayHigh: quote?.ohlc?.high,
        open: quote?.ohlc?.open,
        previousClose: prevClose,
        yearHigh: quote?.["52_week_high"],

        snapshot: item,
      };
    })
    .filter((item) => item?.symbol && item?.lastPrice);
  console.log("SNapshotStocks", snapshotStocks);
  const stocksDb = snapshotStocks.length
    ? snapshotStocks
    : Array.isArray(dataToRender)
      ? dataToRender
      : [];
  const { advances, declines, unChanged } = useMemo(() => {
    let adv = 0;
    let dec = 0;
    let unc = 0;

    stocksDb?.forEach((item) => {
      if (item?.pChange > 0) adv++;
      else if (item?.pChange < 0) dec++;
      else unc++;
    });

    return {
      advances: adv,
      declines: dec,
      unChanged: unc,
    };
  }, [stocksDb]);
  // console.log("Dahsboard index data", dashboardIndexData);
  // const indexQuote = dashboardIndexData?.quote?.data;
  // const liveIndex = livePrices[selectedIndex];

  // const indexLastPrice = liveIndex?.ltp || indexQuote?.last_price;
  // // const indexLastPrice = indexQuote?.last_price;
  // const indexOhlc = indexQuote?.ohlc;
  // const prevClose = dashboardIndexData?.hist_data?.hist?.close?.at(-1);
  // // const prevClose = dashboardIndexData?.quote?.data?.ohlc?.close;
  // const indexPChange = (
  //   ((indexLastPrice - prevClose) / prevClose) *
  //   100
  // ).toFixed(2);
  // console.log("indexPerchange", indexPChange);
  const liveIndex = livePrices?.[selectedIndex];

  const storedIndexPrice = Number(dashboardData?.selectedIndex?.last_price);

  const storedPrevClose = Number(dashboardData?.selectedIndex?.prev_close);

  const liveIndexPrice = Number(liveIndex?.ltp);

  const indexLastPrice = Number.isFinite(liveIndexPrice)
    ? liveIndexPrice
    : storedIndexPrice;

  const prevClose = storedPrevClose;

  const calculatedIndexChange =
    Number.isFinite(indexLastPrice) &&
    Number.isFinite(prevClose) &&
    prevClose !== 0
      ? Number((((indexLastPrice - prevClose) / prevClose) * 100).toFixed(2))
      : 0;

  const livePercentChange = Number(liveIndex?.percentChange);

  const indexPChange = Number.isFinite(livePercentChange)
    ? livePercentChange
    : calculatedIndexChange;
  const getBgColor = (text) => {
    if (text === "BUY" || text === "Bullish") {
      return "#249966";
    } else if (text === "SELL" || text === "Bearish") {
      return "#f87171";
    } else {
      return "#fbbf24";
    }
  };

  const sortPredictionBullish = () => {
    setSignalSort("predictionBullish");
    setCompanySort("none");
    setPercentSort("none");
  };

  const sortPredictionBearish = () => {
    setSignalSort("predictionBearish");
    setCompanySort("none");
    setPercentSort("none");
  };
  const sortVwapBullish = () => setSignalSort("vwapBullish");
  const sortVwapBearish = () => setSignalSort("vwapBearish");

  const sortUtBullish = () => setSignalSort("utBullish");
  const sortUtBearish = () => setSignalSort("utBearish");

  const sortBbBullish = () => setSignalSort("bbBullish");
  const sortBbBearish = () => setSignalSort("bbBearish");

  const getSignalRank = (signal) => {
    const normalized = normalizeSignal(signal);

    const rank = {
      Bullish: 1,
      Neutral: 2,
      Bearish: 3,
    };

    return rank[normalized] || 99;
  };
  const normalizeSignal = (signal) => {
    if (!signal) return "Neutral";

    if (signal === "BUY" || signal === "Buy" || signal === "Bullish") {
      return "Bullish";
    }

    if (signal === "SELL" || signal === "Sell" || signal === "Bearish") {
      return "Bearish";
    }

    return "Neutral";
  };
  //new table data
  // const tableData = [...Object.values(dashboardMarketData || {})].sort(
  const tableData = [...dashboardRows].sort((a, b) => {
    const symbolA = a?.symbol || "";
    const symbolB = b?.symbol || "";

    const quoteA = a?.quote?.data;
    const quoteB = b?.quote?.data;

    const intradayA = a?.intraday || {};
    const intradayB = b?.intraday || {};

    // % Change
    const ltpA = quoteA?.last_price || 0;
    const ltpB = quoteB?.last_price || 0;

    const prevCloseA = quoteA?.ohlc?.close || 0;
    const prevCloseB = quoteB?.ohlc?.close || 0;

    const percentA =
      prevCloseA > 0 ? ((ltpA - prevCloseA) / prevCloseA) * 100 : 0;

    const percentB =
      prevCloseB > 0 ? ((ltpB - prevCloseB) / prevCloseB) * 100 : 0;

    // ==========================
    // Company Sort
    // ==========================
    if (companySort === "asc") {
      return symbolA.localeCompare(symbolB);
    }

    if (companySort === "desc") {
      return symbolB.localeCompare(symbolA);
    }

    // ==========================
    // RSI & MACD Trend
    // ==========================
    if (signalSort === "predictionBullish") {
      return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
    }

    if (signalSort === "predictionBearish") {
      return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
    }

    if (signalSort === "predictionBullish") {
      return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
    }

    if (signalSort === "predictionBearish") {
      return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
    }

    // ==========================
    // VWAP Trend
    // ==========================
    if (signalSort === "vwapBullish") {
      return getSignalRank(a?.vwap_signal) - getSignalRank(b?.vwap_signal);
    }

    if (signalSort === "vwapBearish") {
      return getSignalRank(a?.vwap_signal) - getSignalRank(b?.vwap_signal);
    }

    // ==========================
    // UT Signal
    // ==========================
    if (signalSort === "utBullish") {
      return (
        getSignalRank(intradayA?.ut_signal) -
        getSignalRank(intradayB?.ut_signal)
      );
    }

    if (signalSort === "utBearish") {
      return (
        getSignalRank(intradayB?.ut_signal) -
        getSignalRank(intradayA?.ut_signal)
      );
    }

    // ==========================
    // BB Signal
    // ==========================
    if (signalSort === "bbBullish") {
      return getSignalRank(a?.bbawe_signal) - getSignalRank(b?.bbawe_signal);
    }

    if (signalSort === "bbBearish") {
      return getSignalRank(b?.bbawe_signal) - getSignalRank(a?.bbawe_signal);
    }

    // ==========================
    // % Change
    // ==========================
    if (percentSort === "high") {
      return percentB - percentA;
    }

    if (percentSort === "low") {
      return percentA - percentB;
    }

    return 0;
  });
  useEffect(() => {
    if (indexParam) {
      setSelectedIndex(decodeURIComponent(indexParam));
    }
  }, [indexParam]);
  return (
    <>
      <div className="trend-export">
        {/* <div className="back-btn">
          <button
            className="rec-btn trendpro-back-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>

       

        <div className="select-option dropdown testpage-inner-dropdown">
          <label className="test-page-label">Choose Index</label>

          <div className="select-span-index">
            <select
              className="test-select"
              onChange={handleIndexSelect}
              value={selectedIndex}
            >
              <option value="">Select</option>
              {nseIndicesOptions?.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>

            <span
              className="index-price-data"
              style={{
                color:
                  indexPChange > 0
                    ? "#16a34a"
                    : indexPChange < 0
                      ? "#dc2626"
                      : "#6b7280",
              }}
            >
            
              {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
              {indexPChange}% )
            </span>
          </div>
        </div> */}
        <div className="index-row">
          <div className="select-option dropdown testpage-inner-dropdown">
            <label className="test-page-label">Choose Index</label>

            <div className="select-span-index">
              <select
                className="test-select"
                onChange={handleIndexSelect}
                value={selectedIndex}
              >
                <option value="">Select</option>
                {nseIndicesOptions?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>

              <span
                className="index-price-data"
                // style={{
                //   color:
                //     dataForIndex?.pChange > 0
                //       ? "#16a34a"
                //       : dataForIndex?.pChange < 0
                //         ? "#dc2626"
                //         : "#6b7280",

                // }}
                style={{
                  color:
                    indexPChange > 0
                      ? "#16a34a"
                      : indexPChange < 0
                        ? "#dc2626"
                        : "#6b7280",
                }}
              >
                {/* {dataForIndex?.lastPrice} (
                          {dataForIndex?.pChange > 0 ? "+" : ""}
                          {dataForIndex?.pChange}% ) */}
                {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
                {indexPChange}% )
              </span>
            </div>
          </div>

          <IndexTabs />
        </div>
      </div>

      <div className="test-card-head">
        <div className="card-head test-head-dash">
          <h2>{selectedIndex}</h2>
        </div>

        <div className="test-card-stats">
          <p style={{ color: "#16a34a" }}>
            <IoMdTrendingUp />
            Advances - {advances}
          </p>
          <p style={{ color: "#dc2626" }}>
            <IoMdTrendingDown />
            Declines - {declines}
          </p>
          <p style={{ color: "#6b7280" }}>
            <FiMinusCircle />
            Unchanged - {unChanged}
          </p>
        </div>

        <div
          className="last-updated-head"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "13px",
            color: "#6b7280",
            // marginTop: "10px",
            // marginBottom: "10px",
          }}
        >
          <span>As on {formattedQuoteTime}</span>

          <FiRefreshCw
            size={16}
            onClick={handleRefresh}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#6b7280")}
          />
        </div>
      </div>

      <div className="stock-table-container">
        <table className="stock-table">
          <thead>
            <tr>
              <th>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Company or Ticker
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortCompanyAsc} />
                    <FaChevronDown size={10} onClick={sortCompanyDesc} />
                  </div>
                </div>
              </th>
              <th>Price</th>
              <th>Open</th>
              <th>Close</th>
              {/* <th>% Change</th> */}
              <th>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  % Change
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortPercentHigh} />
                    <FaChevronDown size={10} onClick={sortPercentLow} />
                  </div>
                </div>
              </th>
              <th>Low</th>
              <th>High</th>
              {/* <th>Volume</th> */}
              <th>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Volume
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    {/* <FaChevronUp size={10} onClick={sortVolumeHigh} />
                    <FaChevronDown size={10} onClick={sortVolumeLow} /> */}
                  </div>
                </div>
              </th>
              <th>RSI & MACD Trend</th>
              <th></th>
            </tr>
          </thead>
          {/* <tbody>
            {filteredData?.map((stock) => (
              <tr
                key={stock?.symbol}
                className="stock-row"
                onClick={() => navigate(`/stockInfo/${stock?.company}`)}
              >
                <td>{stock?.company}</td>
                <td>₹{stock?.price}</td>
                <td>₹{stock?.open}</td>
                <td>₹{stock?.close}</td>

                <td
                  style={{
                    color: stock.percent_change >= 0 ? "#249966" : "#f87171",
                    fontWeight: "bold",
                  }}
                >
                  {stock?.percent_change}%
                </td>
                <td>₹{stock.low}</td>
                <td>₹{stock.high}</td>
                <td>{formatVolume(stock.volume)}</td>
                <td>
                  <button
                    className="rec-btn"
                    onClick={() => navigate(`/stockInfo/${stock?.company}`)}
                   
                  >
                    View
                  </button>
                </td>
                <td>
                  <span
                    className={`watchlist-icon ${
                      isInWatchlist(stock?.company) ? "active" : "inactive"
                    }`}
                    onClick={() => handleAdd(stock?.company)}
                  >
                    {isInWatchlist(stock?.company) ? (
                      <FaStar className="star" />
                    ) : (
                      <FiStar className="star" />
                    )}
                  </span>
                </td>
              </tr>
            ))}
          </tbody> */}
          <tbody>
            {filteredData.map((snapshot) => {
              const symbol = snapshot?.symbol;
              const company = snapshot?.company;
              const quote = snapshot?.quote?.data;
              const intraday = snapshot?.intraday;
              const volume = quote?.volume;
              const security_id = snapshot?.security_id;

              const ltp = quote?.last_price;
              const open = quote?.ohlc?.open;
              const high = quote?.ohlc?.high;
              const low = quote?.ohlc?.low;
              const prevClose = snapshot?.prev_close || quote?.ohlc?.close;

              const percentChange =
                prevClose && ltp
                  ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
                  : 0;

              const prediction = snapshot?.prediction;

              return (
                <tr
                  key={symbol}
                  className="stock-row"
                  onClick={() =>
                    navigate(`/stockdetail/${symbol}/${security_id}`)
                  }
                >
                  <td>
                    <div className="trendpro-company">
                      <small>{company}</small>
                      <strong>{symbol}</strong>
                      {/* <small>{symbol}</small> */}
                    </div>
                  </td>
                  <td>₹{ltp ?? "-"}</td>
                  <td>₹{open ?? "-"}</td>
                  <td>₹{prevClose ?? "-"}</td>
                  <td
                    style={{
                      color:
                        percentChange > 0
                          ? "#249966"
                          : percentChange < 0
                            ? "#f87171"
                            : "#64748b",
                      fontWeight: "bold",
                    }}
                  >
                    {percentChange}%
                  </td>
                  <td>₹{low ?? "-"}</td>
                  <td>₹{high ?? "-"}</td>
                  <td>{formatVolume(volume) ?? "-"}</td>
                  <td>
                    <button
                      className="rec-btn"
                      style={{ background: getBgColor(prediction) }}
                    >
                      {prediction || "Refreshing"}
                    </button>{" "}
                  </td>
                  {/* <td>{vwap != null ? `₹${Number(vwap).toFixed(2)}` : "-"}</td> */}

                  {/* <td>{prediction || "Refreshing"}</td>
        <td>{vwapSignal || "Refreshing"}</td>
        <td>{utSignal || "Refreshing"}</td>
        <td>{bbaweSignal || "Refreshing"}</td> */}
                </tr>
                //  <tr
                //           key={stock?.symbol}
                //           className="stock-row"
                //           onClick={() => navigate(`/stockInfo/${stock?.company}`)}
                //         >
                //           <td>{stock?.company}</td>
                //           <td>₹{stock?.price}</td>
                //           <td>₹{stock?.open}</td>
                //           <td>₹{stock?.close}</td>

                //           <td
                //             style={{
                //               color: stock.percent_change >= 0 ? "#249966" : "#f87171",
                //               fontWeight: "bold",
                //             }}
                //           >
                //             {stock?.percent_change}%
                //           </td>
                //           <td>₹{stock.low}</td>
                //           <td>₹{stock.high}</td>
                //           <td>{formatVolume(stock.volume)}</td>
                //           <td>
                //             <button
                //               className="rec-btn"
                //               onClick={() => navigate(`/stockInfo/${stock?.company}`)}

                //             >
                //               View
                //             </button>
                //           </td>
                //           <td>
                //             <span
                //               className={`watchlist-icon ${
                //                 isInWatchlist(stock?.company) ? "active" : "inactive"
                //               }`}
                //               onClick={() => handleAdd(stock?.company)}
                //             >
                //               {isInWatchlist(stock?.company) ? (
                //                 <FaStar className="star" />
                //               ) : (
                //                 <FiStar className="star" />
                //               )}
                //             </span>
                //           </td>
                //         </tr>
              );
            })}
          </tbody>
        </table>

        {/* <div className="stock-mobile-card-wrapper">
          {filteredData?.map((snapshot) => {
            const symbol = snapshot?.symbol;
            const quote = snapshot?.quote?.data;
            const intraday = snapshot?.intraday;
            const volume = quote?.volume;
            const security_id = snapshot?.security_id;

            const ltp = quote?.last_price;
            const open = quote?.ohlc?.open;
            const high = quote?.ohlc?.high;
            const low = quote?.ohlc?.low;
            const prevClose = quote?.ohlc?.close;

            const percentChange =
              prevClose && ltp
                ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
                : 0;
            // const percentChange = stock.percent_change;
            const color = percentChange >= 0 ? "#249966" : "#f87171";
            const prediction = snapshot?.prediction;
            return (
              <div
                key={symbol}
                className="stock-mobile-card"
                style={{ borderLeft: `4px solid ${color}` }}
                onClick={() =>
                  navigate(`/stockdetail/${symbol}/${security_id}`)
                }
              >
               
                <div className="stock-mobile-card-header">
                  <span className="stock-mobile-company">{symbol}</span>

                  <span
                    className={`watchlist-icon ${
                      isInWatchlist(symbol) ? "active" : "inactive"
                    }`}
                    onClick={() => handleAdd(symbol)}
                  >
                    {isInWatchlist(symbol) ? (
                      <FaStar className="star" />
                    ) : (
                      <FiStar className="star" />
                    )}
                  </span>
                </div>

               
                <div className="stock-mobile-card-grid">
                  <div>
                    <p className="label">Price</p>
                    <span>₹{ltp}</span>
                  </div>

                  <div>
                    <p className="label">Open</p>
                    <span>₹{open}</span>
                  </div>

                  <div>
                    <p className="label">Close</p>
                    <span>₹{prevClose}</span>
                  </div>

                  <div>
                    <p className="label">% Change</p>
                    <span style={{ color }}>{percentChange}%</span>
                  </div>

                  <div>
                    <p className="label">Low</p>
                    <span>₹{low}</span>
                  </div>

                  <div>
                    <p className="label">High</p>
                    <span>₹{high}</span>
                  </div>

                  <div>
                    <p className="label">Volume</p>
                    <span>{formatVolume(volume)}</span>
                  </div>

                  <div>
                    <p className="label">RSI & MACD Trend</p>
                    <span>
                      <button
                        className="rec-btn"
                        style={{ background: getBgColor(prediction) }}
                      >
                        {prediction || "Refreshing"}
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div> */}

        <section className="trendpro-mobile-list">
          {filteredData?.map((snapshot) => {
            const symbol = snapshot?.symbol;
            const quote = snapshot?.quote?.data;
            const intraday = snapshot?.intraday;
            const volume = quote?.volume;
            const security_id = snapshot?.security_id;

            const ltp = quote?.last_price;
            const open = quote?.ohlc?.open;
            const high = quote?.ohlc?.high;
            const low = quote?.ohlc?.low;
            const prevClose = quote?.ohlc?.close;

            const percentChange =
              prevClose && ltp
                ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
                : 0;
            // const percentChange = stock.percent_change;
            const color = percentChange >= 0 ? "#249966" : "#f87171";
            const prediction = snapshot?.prediction;
            const histData = snapshot?.hist_data;

            // const ltp = histData?.close?.at(-1);
            // const prevClose = histData?.close?.at(-2);
            // const low = histData?.low?.at(-1);
            // const high = histData?.high?.at(-1);
            // const open = histData?.open?.at(-1);

            const r1 = snapshot?.resDaily?.classic?.R1;
            const s1 = snapshot?.resDaily?.classic?.S1;

            // const symbol = stock?.symbol;
            const company = snapshot?.company;
            // const security_id = stock?.security_id;

            const range = high && low ? high - low : 0;

            // const percentChange =
            //   prevClose && ltp
            //     ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
            //     : null;
            const isPositive = percentChange >= 0;

            const closingStrength =
              range && ltp
                ? Number((((ltp - low) / range) * 100).toFixed(2))
                : null;

            const reboundStrengthValue =
              range && ltp && open
                ? Number(
                    (((Math.min(ltp, open) - low) / range) * 100).toFixed(2),
                  )
                : null;

            const distanceHigh =
              range && ltp
                ? Number((((high - ltp) / range) * 100).toFixed(2))
                : null;

            const signal = normalizeSignal(snapshot?.prediction);

            return (
              <div
                key={symbol}
                className="trendpro-mobile-card"
                onClick={() =>
                  navigate(`/stockdetailpage/${symbol}/${security_id}`)
                }
              >
                <div className="trendpro-mobile-head">
                  <div className="mobile-head-trendpro">
                    <span className="trendpro-company">{company}</span>
                    <h3>{symbol}</h3>
                  </div>

                  <div className="trendpro-mobile-price">
                    <div
                      className="trendpro-mobile-subprice"
                      style={{
                        background: isPositive ? "#ecfdf5" : "#fef2f2",

                        border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
                      }}
                    >
                      <span
                        className={`trendpro-mobile-ltp ${isPositive ? "index-chip-green" : "index-chip-red"}`}
                      >
                        ₹{ltp ?? "-"}
                      </span>

                      <div
                        className={`trendpro-mobile-change ${
                          percentChange >= 0 ? "positive" : "negative"
                        }`}
                      >
                        {percentChange >= 0 ? (
                          <IoMdTrendingUp />
                        ) : (
                          <IoMdTrendingDown />
                        )}

                        <span
                          className={
                            isPositive ? "index-chip-green" : "index-chip-red"
                          }
                        >
                          {ltp - prevClose > 0
                            ? `+${(ltp - prevClose).toFixed(2)}`
                            : (ltp - prevClose).toFixed(2)}
                        </span>

                        <span
                          className={
                            isPositive ? "index-chip-green" : "index-chip-red"
                          }
                        >
                          (
                          {percentChange > 0
                            ? `+${percentChange}`
                            : percentChange}
                          %)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="trendpro-mobile-grid">
                  <div>
                    <span>RSI & MACD</span>
                    <b>
                      <span
                        className={`trendpro-badge ${
                          signal === "Bullish"
                            ? "bull"
                            : signal === "Bearish"
                              ? "bear"
                              : "neutral"
                        }`}
                      >
                        {prediction || "Refreshing"}
                      </span>
                    </b>
                  </div>

                  <div>
                    <span>Open</span>
                    <b>₹{open ?? "-"}</b>
                  </div>

                  <div>
                    <span>High</span>
                    <b>₹{high ?? "-"}</b>
                  </div>

                  <div>
                    <span>Low</span>
                    <b>₹{low ?? "-"}</b>
                  </div>

                  <div>
                    <span>Prev Close</span>
                    <b>₹{prevClose ?? "-"}</b>
                  </div>
                  <div>
                    <span>Volume</span>
                    <b>{formatVolume(volume)}</b>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
      </div>
    </>
  );
};

export default StockTestDetail;
